<template>
  <a-modal v-model="visible" :title="$t('repository.title')" @ok="handleOk" width="800px" class="share-modal">
    <div class="search">
      <a-input-search class="l-search" allowClear v-model="keyword" :placeholder="$t('repository.searchPlaceholder')" @change="search">
        <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
        <img
          class="clear"
          v-if="keyword"
          slot="suffix"
          @click=";(keyword = undefined), search()"
          :src="require('@/assets/icons/icon_gb.png')"
        />
        <a-button class="search-btn" slot="enterButton">
          {{ $t('repository.searchText') }}
        </a-button>
      </a-input-search>
    </div>
    <div class="content">
      <a-table
        :locale="keyword ? searchLocale : locale"
        :columns="columns"
        :data-source="knowledgeList"
        rowKey="id"
        :pagination="pagination"
        :row-selection="{
          type: 'radio',
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        :customRow="customRow"
      >
        <template slot="permission" slot-scope="text, record">
          {{ record.permission === '1' ? $t('repository.permissionType.personal') : $t('repository.permissionType.school') }}
        </template>
      </a-table>
    </div>
    <div class="pagination">
      <Pagination class="list-pagination" :pagination.sync="pagination" @handleTableChange="handlePaginationChange" />
    </div>
    <!-- <div style="margin-bottom: 30px;"></div> -->
    <template slot="footer">
      <div style="height: 35px;">
        <a-button key="submit" type="primary" @click="handleOk">
          {{ $t('repository.ok') }}
        </a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import Pagination from '@/components/pagination/index.vue'
import Empty from '@/components/Empty'
import { getKnowledgeBaseList } from '@/api/ai'

export default {
  name: 'FailureDetails',
  props: {
    resourceList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Pagination
  },
  data() {
    return {
      visible: false,
      keyword: '',
      data: [],
      knowledgeList: [],
      selectedRows: [],
      resId: null,
      columns: [
        {
          title: this.$t('repository.columns.name'),
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: this.$t('repository.columns.permission'),
          dataIndex: 'permission',
          key: 'permission',
          scopedSlots: { customRender: 'permission' }
        }
      ],
      isShare: 2,
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      locale: {
        emptyText: this.$createElement(Empty, {
          props: {
            margin: 80,
            text: this.$t('repository.emptyText'),
            imgSrc: require('@/assets/img/fx_zanwushujv@2x.png')
          }
        })
      },
      searchLocale: {
        emptyText: this.$createElement(Empty, {
          props: {
            margin: 80,
            isSearch: true,
            imgSrc: require('@/assets/img/bj_zanwu.png')
          }
        })
      },
      majorInfo: [],
      selectedMajor: [],
      searchParams: {},
      selectedRowKeys: []
    }
  },
  methods: {
    customRow(record) {
      return {
        on: {
          click: event => {
            this.handleRowClick(record)
          }
        }
      }
    },
    handleRowClick(record) {
      // 单选逻辑：直接将当前行的key赋值给selectedRowKeys
      this.selectedRowKeys = [record.id]
      // 如果需要，可以在这里也更新selectedRows
      // this.selectedRows = [record]
    },
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    showModal(id) {
      this.resId = id
      this.visible = true
      this.init()
    },
    handleOk(e) {
      console.log(this.selectedRowKeys)
      this.$emit(
        'select',
        this.knowledgeList.find(item => item.id === this.selectedRowKeys[0])
      )
      this.visible = false
    },
    handlePaginationChange() {
      console.log('this.pagination ----->', this.pagination.page)
      this.getDatasetList()
    },
    search() {
      this.getDatasetList()
    },
    getEmptyText() {
      if (this.keyword) {
        return this.$createElement(Empty, {
          props: {
            margin: 80,
            isSearch: true
          }
        })
      }
      return this.$createElement(Empty, {
        props: {
          margin: 80,
          text: '暂无数据',
          imgSrc: require('@/assets/img/fx_zanwushujv@2x.png')
        }
      })
    },
    init() {
      this.selectedRows = []
      this.selectedRowKeys = []
      this.isShare = 2
      this.pagination.page = 1
      this.getDatasetList()
    },
    getDatasetList() {
      const params = {
        keyword: this.keyword,
        ...this.searchParams,
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
        status: 1
      }
      getKnowledgeBaseList(params).then(res => {
        if (res.code === 200) {
          this.knowledgeList = res.data.list
          this.pagination.total = res.data.total
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.share-modal {
  color: red;
  /deep/ .ant-modal-body {
    padding-top: 0;
  }
}
.list-pagination {
  // bottom: 50px;
  width: calc(100% - 0px);
  /deep/ .pagination {
    position: static;
    padding: 12px 0;
  }
}
.search {
  margin-top: 15px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
  justify-content: space-between;
  /deep/.ant-input,
  /deep/.ant-select,
  /deep/.ant-input-affix-wrapper {
    width: 237px;
    height: 35px;
    color: #000;
    margin-right: 30px;
    border-radius: 20px;
    .ant-input-prefix,
    .ant-input-suffix {
      > img {
        width: 16px;
        cursor: pointer;
      }
    }
    .ant-input-suffix .clear {
      width: 14px;
      height: 14px;
    }
  }
  /deep/.ant-input-group-wrapper {
    width: 330px;
    height: 35px;
    position: relative;
    .ant-input-prefix {
      // right: auto;
      left: 16px;
      img {
        width: 16px;
      }
    }
    .ant-input-suffix {
      right: 69px;
      .anticon.anticon-close-circle.ant-input-clear-icon {
        display: none;
      }
      .clear {
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
    }
    .ant-input-search {
      width: 100%;
      height: 35px;
      .ant-input {
        width: 100%;
        height: 35px;
        color: #000;
        padding-left: 46px;
        border-radius: 20px;
        box-shadow: none;
        border: 1px solid #d8dce0;
        &:focus {
          border-color: #ffb829;
          box-shadow: 0 0 0 2px rgba(255, 160, 0, 0.2);
        }
      }
    }
    .ant-input-group-addon {
      position: absolute;
      right: 63px;
      top: 0;
      border-radius: 20px;
      z-index: 2;
      background: none;
      .search-btn {
        border-left: 0;
        height: 35px;
        border-color: rgba(0, 0, 0, 0);
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        background: none;
        &::after {
          content: none;
        }
        span {
          display: flex;
          font-size: 14px;
          color: #333333;
          position: relative;
          align-items: center;
          &::before {
            left: -8px;
            content: '';
            width: 1px;
            height: 15px;
            background: #e9e9e9;
            position: absolute;
          }
        }
      }
    }
    // border: 1px solid #D8DCE0;
  }
  /deep/ .ant-radio-button-wrapper-checked {
    background: linear-gradient(248deg, #ff6d00 0%, #f5a623 100%) !important;
    &:hover {
      background: linear-gradient(248deg, #ff6d00 0%, #f5a623 100%) !important;
    }
  }
  /deep/ .ant-radio-button-wrapper {
    background: #edf3fa;
    border: none;
  }
}
.content {
  // height: calc(80vh - 200px);
  max-height: 460px;
  overflow: auto;
  // box-shadow: 0px -1px 10px #ededed;
  /deep/ .ant-table-wrapper .ant-table-thead > tr > th {
    padding: 8px 16px;
  }
  /deep/ .l-empty {
    margin: 65px 0 !important;
  }
  /deep/ .ant-table-placeholder {
    height: 423px;
  }
}
.pagination {
  // position: relative;
}
</style>
